<span>
    <ng-content></ng-content>
</span>
<!-- TODO

    Add feature to add:
    - data-wizard-action
    - click
    - keyup
    - tabindex
    - class.disabled
    - pass extra classes
    <a class="btn btn-primary float-md-right float-left" data-wizard-action="next" (click)="submit()"
                        (keyup.enter)="submit()" tabindex="0"
                        [class.disabled]="addOrUpdateRenderer.formOptions.formDisabled">
                        {{ 'save' | translate }}
                      </a>

-->
